import { ThemeContext } from "@radix-ui/themes";
import { themeDefaults } from "./Theme";
import { PropsWithChildren } from "react";

export function ThemeProvider({
  theme = {},
  children,
}: PropsWithChildren<{ theme?: any }>) {
  // @ts-ignore
  return (
    <ThemeContext.Provider value={{ ...themeDefaults, ...theme }}>
      {children}
    </ThemeContext.Provider>
  );
}
